import { render, staticRenderFns } from "./PaymentForcePostponedAutoSwiftModal.vue?vue&type=template&id=c2eafae0"
import script from "./PaymentForcePostponedAutoSwiftModal.vue?vue&type=script&lang=js"
export * from "./PaymentForcePostponedAutoSwiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports